import React, { useState } from 'react';
import { EyeOutlined, EyeInvisibleOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { SPECIAL_CHARACTERS_REGEX } from '../../../utils/constants';
import './PasswordInput.scss';

const PasswordInput = ({ label, value, onChange, error, showRequirements = true, requirementsValue, wrapperClassName }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [hasSubmittedWithErrors, setHasSubmittedWithErrors] = useState(false);

  const passwordRequirements = [
    {
      label: "Lowercase letter",
      validator: (pwd) => /[a-z]/.test(pwd),
      met: false
    },
    {
      label: "Uppercase letter",
      validator: (pwd) => /[A-Z]/.test(pwd),
      met: false
    },
    {
      label: "Symbol",
      validator: (pwd) => SPECIAL_CHARACTERS_REGEX.test(pwd),
      met: false
    },
    {
      label: "8 characters",
      validator: (pwd) => pwd.length >= 8,
      met: false
    }
  ];

  const getPasswordRequirements = () => {
    const valueToValidate = typeof requirementsValue === 'string' ? requirementsValue : value;
    return passwordRequirements.map(req => ({
      ...req,
      met: req.validator(valueToValidate)
    }));
  };

  const handlePasswordChange = (newValue) => {
    onChange(newValue);
    if (hasSubmittedWithErrors) {
      setHasSubmittedWithErrors(false);
    }
  };

  const currentRequirements = getPasswordRequirements();

  return (
    <div className={`password-input-wrapper ${wrapperClassName ? wrapperClassName : ''}`}>
      <div className="password-input-container">
        {/* <label className="form-label">{label}</label> */}
        <div className="input-with-toggle">
          <input
            type={showPassword ? "text" : "password"}
            placeholder={label}
            value={value}
            onChange={(event) => handlePasswordChange(event.target.value)}
            className={`password-input ${error ? 'error' : ''}`}
          />
          <button
            type="button"
            className="password-toggle"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <EyeInvisibleOutlined rev={undefined} /> : <EyeOutlined rev={undefined} />}
          </button>
        </div>
        {error && <p className='error-message'>{error}</p>}
      </div>

      {showRequirements && (
        <div className="password-requirements">
          <div className="requirements-grid">
            {currentRequirements.map((req, index) => (
              <div
                key={index}
                className={`requirement ${req.met ? 'met' : 'not-met'} ${hasSubmittedWithErrors && !req.met ? 'error-state shake-animation' : ''}`}
              >
                <span className="requirement-icon">
                  {req.met ? <CheckOutlined size={13} /> : <CloseOutlined size={13} />}
                </span>
                <span className="requirement-text">{req.label}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PasswordInput; 